export const DefaultEvent = require("../../../assets/images/default-event.png");
export const DefaultVenue = require("../../../assets/images/default-venue.png");

export const DefaultProfileImage = require("../../../assets/images/default-profile.jpeg");